import Abhishek from "../assets/core-images/Abhishek.jpeg"
import AryanS from "../assets/core-images/AryanS.png"
import Dhruvi from "../assets/core-images/Dhruvi.jpeg"
import Harshita from "../assets/core-images/Harshita.jpg"
import Hetvi from "../assets/core-images/Hetvi.png"
import Tanvi from "../assets/core-images/Tanvi.jpeg"
import Tirth from "../assets/core-images/Tirth.jpeg"
import Utsav from "../assets/core-images/Utsav.jpg"
import Vishal from "../assets/core-images/Vishal.png"
import Vineet from "../assets/core-images/Vineet.jpeg"
import Ayushi from "../assets/core-images/Ayushi.jpeg"
import Forum from "../assets/core-images/Forum.jpeg"
import Nishtha from "../assets/core-images/Nishtha.jpeg"
import AryanG from "../assets/core-images/AryanG.jpeg"
import Smit from "../assets/core-images/Smit.jpeg"

const coreData = {
    lead: {
        id: 1,
        image: Nishtha,
        name: "Nishtha Chitalia",
        description: "Guiding with a 'Google heart' and coding with a 'developer mind,' I'm not just a lead – I'm your architect of innovation. As a committee builder, I weave collaboration into code and turn challenges into opportunities. Let's code a future where creativity knows no limits, and every line is an adventure in building something extraordinary together.",
        instagram: "https://www.instagram.com/chitalianishtha",
        github: "https://www.github.com",
        linkedIn: "https://www.linkedin.com/in/nishtha-chitalia/",
    },
    secretary: {
        id: 2,
        image: AryanG,
        name: "Aryan Gupta",
        description: "Hello there! As the secretary of GDSC, I thrive on keeping things organized and ensuring smooth communication within our tech community. Excited to contribute to our journey of innovation and growth!",
        instagram: "https://www.instagram.com/_aryangpt/",
        github: "https://github.com/AryanGupta2406",
        linkedIn: "www.linkedin.com/in/aryan-gupta-0a348522a",
    },
    treasurer: {
        id: 3,
        image: Forum,
        name: "Forum Sanjanwala ",
        description: "As your committee treasurer, I take care of the finances with attention to detail, making sure everything is clear for everyone. My goal is to keep things transparent, so members feel confident in our financial decisions, fostering trust and responsibility in our operations.",
        instagram: "https://www.instagram.com/forum_1402?igsh=MTY4YjIwd3Jka3NuaA%3D%3D&utm_source=qr",
        linkedIn: "https://www.linkedin.com/in/forum-sanjanwala-4b99881b3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        github: "",
    },

    core: [
        {
            "name": "Abhishek Sinha",
            image: Abhishek,
            "department": "App Development",
            "description": "leading app project and inspire fellow juniors to learning the exciting world of app development  ",
            "instagram": "https://www.instagram.com/okayyabhishek/",
            "linkedIn": "https://www.linkedin.com/in/abhisheksanjeevsinha/",
            "github": "https://github.com/abhinike",
        },
        {
            "name": "Vineet Chotaliya",
            image: Vineet,
            "department": "Web Development",
            "description": "Leading the way as the Web Dev Head at GDSC DJSCE. Passionate about Software Development and Data Science, crafting innovative solutions for tomorrow's challenges.",
            "instagram": "https://www.instagram.com/Vineet___04/",
            "linkedIn": "https://www.linkedin.com/in/vineet-chotaliya/",
            "github": "https://github.com/Vineetttt",
        },
        {
            "name": "Aryan Surve",
            image: AryanS,
            "department": "App Development",
            "description": "As the GDSC App Head, I lead by example, offering inspiration to juniors through my mentorship, fostering a culture of growth. My focus on team spirit and strong leadership qualities empower the team, creating an environment where innovation and collaboration flourish, driving excellence in app development. ",
            "instagram": "https://www.instagram.com/aryan_9324/",
            "linkedIn": "https://www.linkedin.com/in/aryan-surve-889182264/",
            "github": "https://github.com/XeHunter",
        },
        {
            "name": "Hetvi Lodaya",
            image: Hetvi,
            "department": "Creatives",
            "description": "I am the person who is responsible for making  all the ideas come life. 🎨👩🏻\u200d🎨",
            "instagram": "https://instagram.com/hetvi._.l?igshid=MzMyNGUyNmU2YQ%3D%3D&utm_source=qr",
            "linkedIn": "https://www.linkedin.com/in/hetvi-lodaya-a445151b9/",
            "github": "https://github.com/hetvilodaya",
        },
        {
            "name": "Vishal Mandhane ",
            image: Vishal,
            "department": "Marketing",
            "description": "My passion involves helping startups and businesses grow and increase their efficiency through analyzing data as well as brainstorming ideas for building my own startups.",
            "instagram": "https://www.instagram.com/vishalmandhane/",
            "linkedIn": "www.linkedin.com/in/vishal-mandhane",
            "github": "https://github.com/vishal-mandhane",
        },
        {
            "name": "Dhruvi Tank",
            image: Dhruvi,
            "department": "Creatives",
            "description": "A creative thinker pursuing computer engineering. Outside the digital realm, I'm driven by a love for helping others and a relentless curiosity that fuels my continuous learning journey.",
            "instagram": "-",
            "linkedIn": "https://www.linkedin.com/in/dhruvi-tank-b734a1204?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
            "github": "https://github.com/DhruviAshwinTank",

        },
        {
            "name": "Utsav Parekh",
            image: Utsav,
            "department": "Logistics",
            "description": "I\"m a cybersecurity researcher passionate about protecting against threats. I\"m also into entrepreneurship, driven by innovation and problem-solving in diverse domains beyond cybersecurity.",
            "instagram": "https://www.instagram.com/utsav36_/",
            "linkedIn": "www.linkedin.com/in/utsav-parekh",
            "github": "",

        },
        {
            "name": "Ayushi Uttamani",
            image: Ayushi,
            "department": "Publicity",
            "description": "Publicity is my second name, cause I’m an enthusiastic and extremely curious person. I also am a self proclaimed astrophotographer😌",
            "instagram": "https://www.instagram.com/ayushiuttamani",
            "linkedIn": "https://in.linkedin.com/in/ayushi-uttamani-67b049165",
            "github": "https://github.com/ayushiuttamani",
        },
        {
            "name": "Harshita Singhvi",
            image: Harshita,
            "department": "Logistics",
            "description": "Passionate AIML student with a love for organizing events, diving into books, and exploring new destinations. Dedicated to merging artificial intelligence with creativity, creating a dynamic blend of tech and personal interests.",
            "instagram": "https://instagram.com/harshitasinghvi_2209?igshid=NGVhN2U2NjQ0Yg%3D%3D&utm_source=qr", "linkedIn": "https://www.linkedin.com/in/harshita-singhvi?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
            "github": "",
        },
        {
            "name": "Tirth parekh",
            image: Tirth,
            "department": "NSS Coordinator",
            "description": "I am a machine learning enthusiast with expertise in Figma, actively involved in developing various UI/UX projects.In addition, I possess foundational skills in front-end development to complement my focus on machine learning and UI/UX projects.",
            "instagram": "https://www.instagram.com/tirth_parekh_/",
            "linkedIn": "https://www.linkedin.com/in/tirth-ketan-parekh?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
            "github": "https://github.com/tirth-h",
        },
        {
            "name": "Smit Shah",
            image: Smit,
            "department": "Machine Learning",
            "description": "",
            "instagram": "",
            "linkedIn": "",
            "github": "",
        },
        {
            "name": "Tanvi Bhide",
            image: Tanvi,
            "department": "Trinity Coordinator",
            "description": "I'm a confident individual with a passion for exploring new horizons. My interests lie in the dynamic field of web development, where I thrive on creating innovative solutions. I genuinely enjoy engaging with new people, fostering connections, and exchanging ideas.",
            "instagram": "https://www.instagram.com/tabss_007/",
            "linkedIn": "https://www.linkedin.com/in/tabss/",
            "github": "",
        }
    ]

}

export default coreData;
// core: [
//     {
//         id: 1,
//         image: image,
//         name: "Lorem ipsum",
//         description: "“Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur ma”",
//         instagram: "www.instagram.com",
//         github: "www.github.com",
//         linkedIn: "www.linkedin.com",
//         cardColor: "bg-[#FFDF80]"
//     },
//     {
//         id: 2,
//         image: image,
//         name: "Lorem ipsum",
//         description: "“Neque tur, adipisci velit, sed qu”",
//         instagram: "www.instagram.com",
//         github: "www.github.com",
//         linkedIn: "www.linkedin.com",
//         cardColor: "bg-[#B2FFC6]"
//     },
//     {
//         id: 3,
//         image: image,
//         name: "Lorem ipsum",
//         description: "“Neque tur, adipisci velit, sed qu”",
//         instagram: "www.instagram.com",
//         github: "www.github.com",
//         linkedIn: "www.linkedin.com",
//         cardColor: "bg-[#88B4FB]"
//     },
//     {
//         id: 4,
//         image: image,
//         name: "Lorem ipsum",
//         description: "“Neque tur, adipisci velit, sed qu”",
//         instagram: "www.instagram.com",
//         github: "www.github.com",
//         linkedIn: "www.linkedin.com",
//         cardColor: "bg-[#D95556]"
//     },
//     {
//         id: 5,
//         image: image,
//         name: "Lorem ipsum",
//         description: "“Neque tur, adipisci velit, sed qu”",
//         instagram: "www.instagram.com",
//         github: "www.github.com",
//         linkedIn: "www.linkedin.com",
//         cardColor: "bg-[#FFDF80]"
//     },
//     {
//         id: 6,
//         image: image,
//         name: "Lorem ipsum",
//         description: "“Neque tur, adipisci velit, sed qu”",
//         instagram: "www.instagram.com",
//         github: "www.github.com",
//         linkedIn: "www.linkedin.com",
//         cardColor: "bg-[#B2FFC6]"
//     },
// ]